module.exports = __webpack_public_path__ + "static/flexible-collaboration-106078f2cfb90302fb2fbcfc5bd02189.png";